import React from 'react';

function NoPage() {
  return (
    <div className="w3-animate-opacity">
      <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
        <h1 className='title'>PAGE NOT FOUND</h1>
      <p>The page you are looking for does not exist. <br/> <br/> ERROR 404</p>
    </div>
  );
}

export default NoPage;
